var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.client)?_c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('a',{staticClass:"heading-title-2"},[_vm._v(_vm._s(_vm.client.name))]),_c('a',{staticClass:"heading-title-1"},[_vm._v("Info")]),_c('div',[_vm._v("ICO: "+_vm._s(_vm.client.ico))]),_c('a',{attrs:{"href":_vm.client.website,"target":"_blank"}},[_vm._v(_vm._s(_vm.client.website))]),_c('div',{staticClass:"card light mn"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"v-stack gap-3"},[_c('div',{staticClass:"pane-horizontal gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Name:")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.client.contactName || "Not Set"))])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Phone:")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.client.contactPhone || "Not Set"))])]),_c('div',{staticClass:"pane-horizontal gap-3"},[_c('label',{staticClass:"text-right"},[_vm._v("Email:")]),_c('div',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.client.contactEmail || "Not Set"))])])])])]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.client.description),expression:"client.description"}],attrs:{"placeholder":"description","disabled":""},domProps:{"value":(_vm.client.description)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.client, "description", $event.target.value)}}}),_c('div',{staticClass:"h-stack h-end"},[_c('button',{staticClass:"flat dynamic md error",on:{"click":function($event){return _vm.$router.push('/clients/edit/' + _vm.id)}}},[_vm._v(" Edit ")])]),_c('a',{staticClass:"heading-title-1"},[_vm._v("Projects")]),_c('div',{staticClass:"h-stack h-end"},[_c('button',{staticClass:"add",on:{"click":function($event){return _vm.$router.push('/projects/add?client=' + _vm.client._id)}}},[_vm._v(" New ")])]),_c('Table',{attrs:{"items":_vm.client.projects,"defaultColumn":1,"css":"60px 60px 1fr 80px 80px 200px","columns":[
      {
        name: 'State',
        sort: 'alphabet',
        path: ['state'],
      },
      {
        name: 'Icon',
        sort: 'alphabet',
        path: ['icon'],
      },
      {
        name: 'Project',
        sort: 'alphabet',
        path: ['name'],
      },
      {
        name: 'Created',
        sort: 'date',
        path: ['createdDate'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Deadline',
        sort: 'date',
        path: ['deadline'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Vimeo',
        sort: 'alphabet',
        path: ['vimeo'],
        formatType: 'link',
      },
    ]},on:{"rowSelected":function($event){return _vm.$router.push('/projects/detail/' + $event._id)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }